import { render, staticRenderFns } from "./ChatListGrouped.vue?vue&type=template&id=b4aa9006&scoped=true&"
import script from "./ChatListGrouped.vue?vue&type=script&lang=js&"
export * from "./ChatListGrouped.vue?vue&type=script&lang=js&"
import style0 from "./ChatListGrouped.vue?vue&type=style&index=0&id=b4aa9006&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4aa9006",
  null
  
)

export default component.exports